import React, { useState, useRef, useCallback, ChangeEvent } from 'react'
import styled from 'styled-components'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import IconButton from '@mui/material/IconButton'
import FormControlLabel from '@mui/material/FormControlLabel'

import {
  handlePaste,
  ClipboardEventInput,
  handleInputChange,
  clearSearch,
} from './SearchInputUtils'

const SearchInputContainer = styled(FormControlLabel)`
  width: 22rem;
  margin: 0 !important;
  .MuiFormControlLabel-label {
    display: none;
  }

  @media only screen and (max-width: 700px) {
    width: 100%;
  }
`

interface SearchInputProps {
  onSearch: (value: string) => void
}

const SearchInput = ({ onSearch }: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [clearable, setClearable] = useState(false)

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      handleInputChange(e.target.value, onSearch, setClearable)
    },
    [onSearch],
  )

  const handlePasteCallback = useCallback((e: ClipboardEventInput) => {
    handlePaste(e)
  }, [])

  const handleClearSearch = useCallback(() => {
    clearSearch(inputRef, onSearch, setClearable)
  }, [onSearch])

  return (
    <SearchInputContainer
      control={
        <TextField
          inputRef={inputRef}
          data-testid="search-input-contribution"
          fullWidth
          size="small"
          variant="standard"
          onChange={handleChange}
          onPaste={handlePasteCallback}
          placeholder="Use commas to separate keywords"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {clearable && (
                  <IconButton
                    size="small"
                    onClick={handleClearSearch}
                    aria-label="clear search"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      }
      label="Search contributions"
    />
  )
}

export { SearchInput }
